import { DtoBasket } from '@epicuro-next/data/baskets-dto';
import { BasketStatus } from 'graphql-api/baskets-api-interfaces';

import { mapDtoStatus } from './map-dto-status';

export function isDtoBasketPlaced(basket: DtoBasket) {
  return mapDtoStatus(basket.status) !== BasketStatus.New;
}
